<template>
  <v-card class="themeBackgroundPassport2 v-card--flat" v-resize="onResize">
    <v-card class="mb-8 v-card--flat" v-if="!$store.getters.getMobilePhoneActive">
      <div class="containerForPassport" style="height: 55em !important;">
        <v-img
          class="imageBlurPassport"
          :src="setBackgroundImageForAccount()"
          v-if="!$store.getters.getMobilePhoneActive"
        ></v-img>
        <v-layout
          v-if="!$store.getters.getMobilePhoneActive"
          align-center
          justify-center
          row
          fill-height
        >
          <v-card class="passportCard transparent elevation-0">
            <v-layout align-center justify-center row fill-height>
              <v-flex xs8 class="test">
                <h1 class="passPortText">{{$translate('USER_PASSPORT')}}</h1>
                <h3
                  class="mb-2 passPortText"
                >{{$translate('USER_PASSPORT_DESC')}}</h3>
              </v-flex>
            </v-layout>
            <br><br><br>
            <v-layout align-center justify-center row fill-height>
              <v-flex xs4>
                <v-card class="transparent elevation-0">
                  <v-img class="leftPassportPhotoPassport" :src="require('../assets/paspoortlinks.png')">
                    <v-card class="innerPassport elevation-0">
                      <form ref="form">
                        <v-text-field
                          style="padding-left: 0.4em; padding-right: 0.4em;"
                          :label="$translate('FIRSTNAME')"
                          prepend-icon="person"
                          required
                          v-model="userDetails[11]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('LASTNAME')"
                          prepend-icon="person"
                          required
                          v-model="userDetails[12]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('EMAIL')"
                          required
                          disabled
                          prepend-icon="alternate_email"
                          userDetails
                          v-model="userDetails[1]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          label="Account-Id"
                          disabled
                          prepend-icon="supervised_user_circle"
                          userDetails
                          v-model="userDetails[4]"
                        ></v-text-field>
                        <v-select
                          :items="states"
                          class="formElements"
                          :label="$translate('COUNTRY')"
                          item-value="name"
                          item-text="name"
                          prepend-icon="flag"
                          required
                          v-model="userDetails[18]"
                        ></v-select>
                        <v-layout row>
                          <v-flex xs8>
                            <v-text-field
                              class="formElements"
                              :label="$translate('PLACE_OF_RESIDENCE')"
                              prepend-icon="location_city"
                              required
                              v-model="userDetails[17]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              class="formElements"
                              :label="$translate('REGISTER_ZIPCODE')"
                              prepend-icon="drafts"
                              required
                              v-model="userDetails[16]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs8>
                            <v-text-field
                              class="formElements"
                              :label="$translate('STREET')"
                              prepend-icon="house"
                              required
                              v-model="userDetails[14]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs4>
                            <v-text-field
                              class="formElements"
                              :label="$translate('HOUSE_NUMBER')"
                              prepend-icon="looks_5"
                              required
                              v-model="userDetails[15]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-menu
                          ref="menu1"
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="formElements"
                              v-model="computedDateFormattedDob"
                              :label="$translate('DATE_OF_BIRTH')"
                              prepend-icon="event"
                              clearable
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            min="1900-01-01"
                            first-day-of-week="1"
                            :max="new Date().toISOString().substr(0, 10)"
                            v-model="dateOfBirth"
                            @input="$refs.menu1.save(dateOfBirth)"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          class='formElements'
                          :label="$translate('REGISTER_LICENSE')"
                          prepend-icon="directions_car"
                          required
                          v-model="userDetails[20]"
                        ></v-text-field>
                      </form>
                      <v-flex xs11 class="mt-1 pl-4">
                        <p class="mt-1">
                          <a
                            @click="goToPrivacyStatement()"
                            target="_blank"
                            class="link"
                            style="text-decoration: underline;"
                          >{{$translate('REGISTER_PRIVACY_STATEMENT')}}</a>
                        </p>
                      </v-flex>
                    </v-card>
                  </v-img>
                </v-card>
              </v-flex>
              <v-flex xs4>
                <v-card class="rightPassportPhotoPassport transparent elevation-0">
                  <v-img :src="require('../assets/paspoortrechts.png')">
                    <v-card class="innerPassport elevation-0">
                      <v-layout row>
                        <v-img style="border-radius: 10px; cursor:pointer;" :src="profilePicture" width="60" height="100">
                          <image-loader class="mt-4" :properties="properties" v-on:load_logo="setImageElement"></image-loader>
                        </v-img>
                      </v-layout>
                      <v-layout style="width: 95%;" column>
                        <h3 class="pa-1" :style="`color: ${$vuetify.theme.primary}`">
                          {{$translate('USER_PICTURE_UPLOAD')}}</h3>
                        <v-layout class="mt-2 mb-2" row>
                          <v-img :src="qrPicture" width="120" height="200">
                          </v-img>
                        </v-layout>

                        <h4
                          :style="`color: ${$vuetify.theme.primary}`"
                        >{{$translate('USER_QR_CODE')}}</h4>
                        <v-layout class="progressBarPassport" align-start justify-start row>
                        </v-layout>
                      </v-layout>
                    </v-card>
                    <v-layout align-end justify-end>
                      <v-btn
                        color="primary"
                        class="mb-4 mr-4"
                        round
                        medium
                        @click="updateUser()"
                      >{{$translate('SAVE')}}</v-btn>
                    </v-layout>
                  </v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-layout>
      </div>

      <v-card class="blokje v-card--flat">
        <!--switch between your interests and favorites-->
        <v-layout justify-center align-center row wrap>
          <template>
            <v-card :color="switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                    :dark="switchContent"
                    @click="switchContent = true"
                    class="toggleProducts">
              <v-layout justify-center align-center column fill-height>
                <v-icon>mood</v-icon>
                <h4><b>{{$translate('USER_INTERRESTS')}}</b></h4>
              </v-layout>
            </v-card>
          </template>
          <v-card :color="!switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                  :dark="!switchContent"
                  @click="switchContent = false"
                  class="toggleProducts">
            <v-layout justify-center align-center column fill-height>
              <v-icon>favorite</v-icon>
              <h4><b>{{$translate('USER_FAVORITES')}}</b></h4>
            </v-layout>
          </v-card>
        </v-layout>
        <!-- Web version - Your interests  -->
        <v-flex xs12 class="blokje" style="padding: 2.5em 0 1em 0">
                <h1 :style="`color: ${$vuetify.theme.primary}`">{{ contentSwitchTitle }}</h1>
                <h3 :style="`color: ${$vuetify.theme.primary}`">{{ contentSwitchDesc }}</h3>
              </v-flex>

        <div class="surroundingInterestsPassport" v-if="switchContent && !$store.getters.getMobilePhoneActive">
        <v-layout row wrap class="text">


          <v-flex xs3>
            <v-card class="rounded-favourite-card-passport" style="text-align:center">
              <v-layout column>
                <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('USER_INTERRESTS')}}</h2>
                <v-container fluid>
                  <v-flex v-for="(item, index) in tags" :key="index" xs-1>
                    <v-switch
                      v-model="item.Selected"
                      :label="item.TagGroup"
                    ></v-switch>
                  </v-flex>
                </v-container>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs9 v-if="userInterests">
            <v-card
              v-if="seeTheListOfSuggestions && paginatedSuggestions.length > 0"
              flat
              elevation="3"
              class="grey lighten-2 rounded-favourite-card-passport ml-1"
              style=" margin-bottom: 1em !important; margin-top: -0.5em; min-height: 55em;"
            >
              <v-card flat v-for="(suggestion, key) in paginatedSuggestions" :key="key">
                <v-layout row wrap>
                  <v-card class="v-card--flat" style="width: 30%;">
                    <img
                      v-if="suggestion.PictureUrl !== 'NULL'"
                      class="passportEvents"
                      contain :aspect-ratio="16/9"
                      :src="suggestion.PictureUrl"
                    >
                    <img
                      v-else
                      class="passportEvents"
                      contain :aspect-ratio="16/9"
                      src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                    >
                  </v-card>
                  <v-card class="v-card--flat interestMidSection" style="width: 60%;">
                    <v-layout column class="ml-1">
                      <h3
                        v-if="suggestion.EventTranslationName !== ''"
                        :style="`color: ${$vuetify.theme.primary}`"
                      >{{suggestion.EventTranslationName}}</h3>
                      <h3 v-else :style="`color: ${$vuetify.theme.primary}`">{{suggestion.Name}}</h3>
                      <p class="textWidthPassport">{{suggestion.Description}}</p>
                    </v-layout>
                  </v-card>
                  <v-card class="v-card--flat" style="width: 10%;">
                    <v-btn fab>
                      <v-icon
                        :color="suggestion.Favourite ? 'red' : 'grey'"
                        large
                        @click="toggleFavourite(suggestion)"
                      >favorite</v-icon>
                    </v-btn>
                  </v-card>
                </v-layout>
              </v-card>
            </v-card>
            <v-card class="ml-2 mt-4 transparent elevation-0" v-else>
              <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('GET_PERS_SUG')}}</h2>
            </v-card>
            <v-layout
              v-if="paginatedSuggestions.length > 0"
              justify-end
              row
              style="margin-bottom: 10em;"
            >
              <v-pagination
                class="pagination mt-0"
                total-visible="5"
                v-model="pageTwo"
                :length="nPagesTwo"
                @input="selectPageTwo"
                @next="nextPageTwo"
                @previous="previousPageTwo"
              ></v-pagination>
            </v-layout>
          </v-flex>
          <v-flex v-else xs9 style="min-height: 45em;">
            <v-layout justify-center align-center column fill-height>
              <h1 :style="`color: ${$vuetify.theme.primary}`">
                {{$translate('GETTING_USER_INTERESTS')}}</h1>
              <v-progress-circular
                :size="50"
                :width="5"
                :color="$vuetify.theme.primary"
                indeterminate
              ></v-progress-circular>
            </v-layout>
          </v-flex>
        </v-layout>
        </div>
        <!-- Web version - Your favorites -->
        <div class="surroundingInterestsPassport"
             v-if="!switchContent && !$store.getters.getMobilePhoneActive">
          <v-layout justify-center align-center row wrap>
            <v-flex
              v-for="(eventData, key) in paginatedFavorites"
              :key="key"
              class="rounded-favourite-card-passport"
              xs5
              pa-1
              d-flex
            >
              <v-card
                class="d-flex favouriteCardPassport rounded-favourite-card-passport"
                elevation="3"
              >
                <v-layout column>
                  <v-img
                    :src="eventData.PictureUrl"
                    contain
                    :aspect-ratio="16/9"
                    class="grey lighten-2 favouriteImagePassport rounded-favourite-card-passport"
                  >
                    <v-layout justify-end align-end>
                      <v-icon
                        :color="eventData.Favourite ? 'red' : 'grey'"
                        large
                        @click="toggleFavourite(eventData)"
                      >favorite</v-icon>
                    </v-layout>
                  </v-img>
                  <div style="padding: 1em; height: 20em; overflow: auto;">
                    <h2>{{eventData.EventTranslationName}}</h2>
                    <p>{{eventData.Description}}</p>
                  </div>
                  <v-layout row justify-end>
                    <v-btn
                      @click="goToActvityDetailScreen(eventData)"
                      color="secondary"
                      round
                    >{{$translate('ORDER')}}</v-btn>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout justify-end row style="margin-bottom: 10em;">
            <v-pagination
              class="pagination mt-0"
              total-visible="5"
              v-model="page"
              :length="nPages"
              @input="selectPage"
              @next="nextPage"
              @previous="previousPage"
            ></v-pagination>
          </v-layout>
        </div>
      </v-card>
    </v-card>
        <!-- Mobile responsiveness -->
        <v-layout
          v-else
          align-center
          justify-center
          row
          fill-height
        >
          <v-img
            class="imageBlurPassport2"
            :src="setBackgroundImageForAccount()"
          ></v-img>
          <!-- My account, text -->
          <v-card class="blokje transparent elevation-0">
            <v-layout align-center justify-center row fill-height>
              <v-flex xs8 class="MyAccountMobile">
                <h1 class="passPortText">{{$translate('USER_PASSPORT')}}</h1>
                <h3
                  class="mb-2 passPortText"
                >{{$translate('USER_PASSPORT_DESC')}}</h3>
              </v-flex>
            </v-layout>
           <!--form -->
            <v-layout align-center justify-center fill-height>
                <v-flex xs12>
                  <v-card class="formMobile">
                      <form ref="form">
                        <v-text-field
                          style="padding-left: 0.4em; padding-right: 0.4em;"
                          :label="$translate('FIRSTNAME')"
                          prepend-icon="person"
                          required
                          v-model="userDetails[11]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('LASTNAME')"
                          prepend-icon="person"
                          required
                          v-model="userDetails[12]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('EMAIL')"
                          required
                          disabled
                          prepend-icon="alternate_email"
                          userDetails
                          v-model="userDetails[1]"
                        ></v-text-field>
                        <v-select
                          :items="states"
                          class="formElements"
                          :label="$translate('COUNTRY')"
                          item-value="name"
                          item-text="name"
                          prepend-icon="flag"
                          required
                          v-model="userDetails[18]"
                        ></v-select>
                        <v-text-field
                          class="formElements"
                          :label="$translate('PLACE_OF_RESIDENCE')"
                          prepend-icon="location_city"
                          required
                          v-model="userDetails[17]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('REGISTER_ZIPCODE')"
                          prepend-icon="drafts"
                          required
                          v-model="userDetails[16]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('STREET')"
                          prepend-icon="house"
                          required
                          v-model="userDetails[14]"
                        ></v-text-field>
                        <v-text-field
                          class="formElements"
                          :label="$translate('HOUSE_NUMBER')"
                          prepend-icon="looks_5"
                          required
                          v-model="userDetails[15]"
                        ></v-text-field>
                        <v-menu
                          ref="menu1"
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              class="formElements"
                              v-model="computedDateFormattedDob"
                              :label="$translate('DATE_OF_BIRTH')"
                              prepend-icon="event"
                              clearable
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="picker"
                            min="1900-01-01"
                            first-day-of-week="1"
                            :max="new Date().toISOString().substr(0, 10)"
                            v-model="dateOfBirth"
                            @input="$refs.menu1.save(dateOfBirth)"
                          ></v-date-picker>
                        </v-menu>
                        <v-text-field
                          class='formElements'
                          :label="$translate('REGISTER_LICENSE')"
                          prepend-icon="directions_car"
                          required
                          v-model="userDetails[20]"
                        ></v-text-field>
                      </form>
                    </v-card>
                </v-flex>
            </v-layout>
                <v-layout justify-center align-center row wrap>
                  <template>
                    <v-card :color="switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                            :dark="switchContent"
                            @click="switchContent = true"
                            class="toggleProducts">
                      <v-layout justify-center align-center column fill-height>
                        <v-icon>mood</v-icon>
                        <h4><b>{{$translate('USER_INTERRESTS')}}</b></h4>
                      </v-layout>
                    </v-card>
                  </template>
                  <v-card :color="!switchContent ? $vuetify.theme.primary : 'white lighten-1'"
                          :dark="!switchContent"
                          @click="switchContent = false"
                          class="toggleProducts">
                    <v-layout justify-center align-center column fill-height>
                      <v-icon>favorite</v-icon>
                      <h4><b>{{$translate('USER_FAVORITES')}}</b></h4>
                    </v-layout>
                  </v-card>
                </v-layout>
          </v-card>
        </v-layout>
    <v-card class="blokje v-card--flat">
      <div class="text-xs-center">
        <v-dialog
          v-model="locationNotFound"
          width="500"
        >
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              {{$translate('USER_DETAILS_NOT_SAVED')}}
            </v-card-title>
            <v-card-text>
              {{$translate('USER_LOCATION_NOT_FOUND_DESC2')}}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="locationNotFound = false"
              >
                {{$translate('CLOSE')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
       <!-- Mobile version - Your interests -->
        <div class="yourInterestsMobile" v-if="switchContent && $store.getters.getMobilePhoneActive">
          <v-layout justify-center align-center row wrap class="text">
            <v-flex xs12 v-if="userInterests">
              <v-card
                v-if="seeTheListOfSuggestions && paginatedSuggestions.length > 0"
                flat
                elevation="3"
                class="grey lighten-2 rounded-favourite-card-passport ml-1"
                style=" margin-bottom: 1em !important; margin-top: -0.5em; min-height: 55em;"
              >
                <v-card flat v-for="(suggestion, key) in paginatedSuggestions" :key="key">
                  <v-layout row wrap>
                    <v-card class="v-card--flat" style="width: 30%;">
                      <v-img
                        v-if="suggestion.Picture !== 'NULL'"
                        class="passportEvents"
                        contain :aspect-ratio="16/9"
                        :src="suggestion.Picture"
                      />
                      <v-img
                        v-else
                        class="passportEvents"
                        contain :aspect-ratio="16/9"
                        src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                      />
                    </v-card>
                    <v-card class="v-card--flat interestMidSection" style="width: 60%;">
                      <v-layout column class="ml-1">
                        <h3
                          v-if="suggestion.EventTranslationName !== ''"
                          :style="`color: ${$vuetify.theme.primary}`"
                          style="margin-top:1em;"
                        >{{suggestion.EventTranslationName}}</h3>
                        <h3 v-else :style="`color: ${$vuetify.theme.primary}`">{{suggestion.Name}}</h3>
                        <p class="textWidthPassport">{{suggestion.Description}}</p>
                      </v-layout>
                    </v-card>
                    <v-card class="v-card--flat" style="width: 10%; margin-left:-2em;">
                      <v-btn fab>
                        <v-icon
                          :color="suggestion.Favourite ? 'red' : 'grey'"
                          large
                          @click="toggleFavourite(suggestion)"
                        >favorite</v-icon>
                      </v-btn>
                    </v-card>
                  </v-layout>
                </v-card>
              </v-card>
              <v-card class="ml-2 mt-4 transparent elevation-0" v-else>
                <h2 :style="`color: ${$vuetify.theme.primary}`">{{$translate('GET_PERS_SUG')}}</h2>
              </v-card>
              <v-layout
                v-if="paginatedSuggestions.length > 0"
                justify-end
                row
                style="margin-bottom: 10em;"
              >
                <v-pagination
                  class="pagination mt-0"
                  total-visible="5"
                  v-model="pageTwo"
                  :length="nPagesTwo"
                  @input="selectPageTwo"
                  @next="nextPageTwo"
                  @previous="previousPageTwo"
                ></v-pagination>
              </v-layout>
            </v-flex>
            <v-flex v-else xs12 style="min-height: 45em;">
              <v-layout justify-center align-center column fill-height>
                <h1 :style="`color: ${$vuetify.theme.primary}`">{{$translate('GETTING_USER_INTERESTS')}}</h1>
                <v-progress-circular
                  :size="50"
                  :width="5"
                  :color="$vuetify.theme.primary"
                  indeterminate
                ></v-progress-circular>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <!-- mobile version - Your favorites -->
        <div class="surroundingInterestsPassport" v-if="!switchContent && $store.getters.getMobilePhoneActive">
          <v-layout justify-center align-center row wrap>
            <v-flex
              v-for="(eventData, key) in paginatedFavorites"
              :key="key"
              class="rounded-favourite-card-passport"
              xs12
              pa-1
              d-flex
            >
              <v-card
                class="d-flex favouriteCardPassport rounded-favourite-card-passport"
                elevation="3"
              >
                <v-layout column>
                  <v-img
                    :src="eventData.Picture"
                    contain
                    :aspect-ratio="16/9"
                    class="grey lighten-2 favouriteImagePassport rounded-favourite-card-passport"
                  >
                    <v-layout justify-end align-end>
                      <v-icon
                        :color="eventData.Favourite ? 'red' : 'grey'"
                        large
                        @click="toggleFavourite(eventData)"
                      >favorite</v-icon>
                    </v-layout>
                  </v-img>
                  <div style="padding: 1em; height: 20em; overflow: auto;">
                    <h2>{{eventData.EventTranslationName}}</h2>
                    <p>{{eventData.Description}}</p>
                  </div>
                  <v-layout row justify-end>
                    <v-btn
                      @click="goToActvityDetailScreen(eventData)"
                      color="secondary"
                      round
                    >{{$translate('ORDER')}}</v-btn>
                  </v-layout>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout justify-end row style="margin-bottom: 10em;">
            <v-pagination
              class="pagination mt-0"
              total-visible="5"
              v-model="page"
              :length="nPages"
              @input="selectPage"
              @next="nextPage"
              @previous="previousPage"
            ></v-pagination>
          </v-layout>
        </div>
      <!-- Mobile version - filter activities -->
      <v-bottom-nav
        v-if="$store.getters.getMobilePhoneActive"
        fixed
        :active.sync="activeBtn"
        :value="showNav"
        color="white"
      >
        <v-layout justify-center align-center>
          <div>
            <v-bottom-sheet v-model="sheet">
              <template v-slot:activator>
                <v-layout justify-space-between>
                  <v-btn flat>
                    <span>{{$translate('FILTER_ACTIVITIES')}}</span>
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                </v-layout>
              </template>
              <v-card>
                <v-card  elevation="5">
                  <v-flex xs12>
                    <v-layout column >
                      <v-layout row >
                      <h2 class="userInterests":style="`color: ${$vuetify.theme.primary}`">{{$translate('USER_INTERRESTS')}}</h2>
                        <v-btn flat @click="sheet = false">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-layout>
                      <v-container fluid>
                        <v-flex v-for="(item, index) in tags" :key="index" xs-1>
                          <v-switch
                            v-model="item.Selected"
                            :label="item.TagGroup"
                          ></v-switch>
                        </v-flex>
                      </v-container>
                    </v-layout>
                  </v-flex>
                  </v-card>

              </v-card>
            </v-bottom-sheet>
          </div>
        </v-layout>
      </v-bottom-nav>

    </v-card>

      <v-dialog v-model="deletingFavourite" persistent max-width="390">
        <v-card class="confirmLoadingDialog">
              <v-layout column justify-center align-start>
                <v-card-title class="headline">{{$translate('DEL_FAV')}}</v-card-title>
                  <v-card-text>
                    <p class="setFontSize">
                      {{$translate('SURE_DELETE_ACTIVITY')}}
                      <b>{{currentFavorite.Name}}</b>
                      {{$translate('SURE_DELETE_FAV')}}
                    </p>
                  </v-card-text>
              </v-layout>
             <v-card-actions>
                <v-btn color="secondary" flat @click="deletingFavourite = false">{{$translate('CANCEL')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  flat
                  @click="deleteFavourite(currentFavorite)"
                >{{$translate('DELETE')}}</v-btn>
             </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
</template>
<script>
  import ImageLoader from "@/components/media/ImageLoader";
  import appConfig from "../../config/app_config";
  import * as dssRequest from "../api/dssRequest";
  import { store } from "../store";
  import UserObject from "../objects/UserObject";
  import { countries } from "../shared/countries.js";
  import _ from "lodash";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        sheet: false,
        showNav: true,
        e1: 1,
        steps: 2,
        switchContent: true,
        states: countries,
        //interests
        userInterests: true,
        //favorites
        seeTheListOfSuggestions: true,
        deletingFavourite: false,
        currentFavorite: {},
        paginatedFavorites: [],
        page: 1,
        nPages: 1,
        elementXpage: 6,
        favoriteItems: [],
        paginatedSuggestions: [],
        pageTwo: 1,
        nPagesTwo: 1,
        elementXpageTwo: 6,
        suggestionItems: [],
        eventData: {},
        //suggestions
        tags: [],
        //user form
        locationNotFound: false,
        profilePicture: "",
        qrPicture: "",
        userData: {},
        userDetails: {},
        form: {},
        menu1: false,
        dateOfBirth: null,
        levelbar: 90,
        properties: {
          showOnlyButton: true,
          title: "logo",
          signalName: "load_logo",
          deletable: false,
          pictureUrl: "",
          maxWidth: appConfig.maxSize.logo.w,
          maxHeight: appConfig.maxSize.logo.h,
          scale: "h"
        },
      };
    },
    watch: {
      '$store.getters.getUserLanguage': function(newV, oldV) {
        if (newV !== oldV) {
          this.getEventsOfUserInterests();
          this.getFavourites();
        }
      },
      favoriteItems: function(next, to) {
        this.page = 1;
        this.recountPage();
      },
      suggestionItems: function(next, to) {
        this.pageTwo = 1;
        this.recountPageTwo();
      },
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      }
    },
    components: {
      ImageLoader
    },
    created() {
      this.$store.commit("setCurrentMainComponent", "PassportPage");
    },
    beforeDestroy() {
      this.$store.commit("setCurrentMainComponent", "");
    },
    mounted() {

      window.scrollTo({
        top: 0,
        left: 0,
      });
      // this.getTagGroupsForUser();
      this.getUserData();
      this.getFavourites();
      this.getEventsOfUserInterests();
    },
    computed: {
      computedDateFormattedDob() {
        return this.formatDate(this.dateOfBirth);
      },
      contentSwitchTitle() {
        return this.switchContent === true ? this.$translate('USER_INTERRESTS') : this.$translate('USER_FAVORITES');
      },
      contentSwitchDesc() {
        return this.switchContent === true ? this.$translate('USER_INTERRESTS_DESC') : this.$translate('USER_FAVORITES_DESC');
      },
    },
    methods: {
      onInput (val) {
        this.steps = parseInt(val)
      },
      nextStep (n) {
        if (n === this.steps) {
          this.e1 = 1
        } else {
          this.e1 = n + 1
        }
      },
      setImageElement(e) {
        this.properties.pictureUrl = e.url;
        this.profilePicture = e.url;
      },
      selectPage(number) {
        this.recountPage();
      },
      nextPage() {
        this.recountPage();
      },
      previousPage() {
        this.recountPage();
      },
      recountPage() {
        this.nPages = Math.ceil(this.favoriteItems.length / this.elementXpage);
        let start = (this.page - 1) * this.elementXpage;
        this.paginatedFavorites = [];
        this.paginatedFavorites = this.favoriteItems.filter(
          (e, i) => i >= start && i < start + this.elementXpage
        );
      },
      selectPageTwo(number) {
        this.recountPageTwo();
      },
      nextPageTwo() {
        this.recountPageTwo();
      },
      previousPageTwo() {
        this.recountPageTwo();
      },
      recountPageTwo() {
        this.nPagesTwo = Math.ceil(
          this.suggestionItems.length / this.elementXpageTwo
        );
        let start = (this.pageTwo - 1) * this.elementXpageTwo;
        this.paginatedSuggestions = [];
        this.paginatedSuggestions = this.suggestionItems.filter(
          (e, i) => i >= start && i < start + this.elementXpageTwo
        );
      },
      formatDate(date) {
        if (!date) return null;
        console.log("Brian date", date);

        const [year, month, day] = date.split('-');
        this.dateOfBirth = `${day}-${month}-${year}`;
        console.log("Brian this.dateOfBirth", this.dateOfBirth);

        return this.dateOfBirth;
      },
      // getJSONP(url, success) {

      // var ud = '_' + +new Date,
      //     script = document.createElement('script'),
      //     head = document.getElementsByTagName('head')[0]
      //            || document.documentElement;

      // window[ud] = function(data) {
      //     head.removeChild(script);
      //     success && success(data);
      // };

      // script.src = url.replace('callback=?', 'callback=' + ud);
      // head.appendChild(script);

      // },
      Get(url){
        var Httpreq = new XMLHttpRequest(); // a new request
        Httpreq.open("GET",url,false);
        Httpreq.send(null);
        return Httpreq.responseText;
      },

      updateUser() {

        if (this.userDetails[15] !== "" && this.userDetails[16] !== "" && this.userDetails[17] !== "") {
          var json_obj = JSON.parse(this.Get('https://nominatim.openstreetmap.org/search?q=' + this.userDetails[15] + '+' + this.userDetails[14] + ',+' + this.userDetails[17] + '&format=json&polygon=1&addressdetails=1'));
          if(!_.isEmpty(json_obj)){
            const lat = json_obj[0].lat;
            const lon = json_obj[0].lon;
            this.$store.commit("setUserOrderLon", lon);
            this.$store.commit("setUserOrderLat", lat);
          }
          else{
            this.locationNotFound = true;
            return;
          }
        }
        let payload = {
          Email: this.userDetails[1],
          FirstName: this.userDetails[11],
          LastName: this.userDetails[12],
          DoB: this.dateOfBirth,
          LicensePlate: this.userDetails[20],
          City: this.userDetails[17],
          PostalCode: this.userDetails[16],
          Street: this.userDetails[14],
          Nr: this.userDetails[15],
          Country: this.userDetails[18],
          Picture: this.properties.pictureUrl,
          Longitude: this.$store.getters.getUserOrderLon,
          Latitude: this.$store.getters.getUserOrderLat
        };
        payload.FunctionId = "UserFunctionLibrary::updateUser";
        dssRequest.doRequest(
          response => {
            console.log("The generic call updateUser was successful", response);
            this.getUserData();
            window.EventBus.fire(
              "activateSnackBar",
              this.$translate('USER_DETAILS_SAVED')
            );
          },
          error => {
            console.log("The generic call updateUser was not successful", error);
          },
          "updateUser",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      onResize() {
        this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        this.carouselHeight = 8.1 * window.innerHeight;
      },
      saveTagGroupsForUser(data) {
        let payload = {
          FunctionId: "TagsFunctionLibrary::saveTagGroupsForUser",
          PartnerId: -1,
          TagGroups: this.tags
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The call for saveTagGroupsForUser was successful",
              response
            );
            this.getEventsOfUserInterests();
          },
          error => {
            console.log(
              "The call for saveTagGroupsForUser was not successful",
              error
            );
          },
          "communicateWithDBLibrary",
          store.getters.getCurrentAccountId,
          payload
        );
      },
      goToActvityDetailScreen(eventData) {
        this.$store.commit("setChosenEvent", eventData.EventId);

        this.$router.push({
          path: "/" + store.getters.getRegion +"/" + 'event=' + eventData.EventId
        });
      },
      getTagGroupsForUser() {
        let payload = {
          PartnerId: -1,
          FunctionId: "TagsFunctionLibrary::getTagGroupsForUser"
        };
        dssRequest.doRequest(
          response => {
            console.log(
              "The call for getTagGroupsForUser was successful",
              response
            );
            this.tags = response.data.TagGroups;
          },
          error => {
            console.log(
              "The call for getTagGroupsForUser was not successful",
              error
            );
          },
          "communicateWithDBLibrary",
          store.getters.getCurrentAccountId,
          payload
        );
      },
      getUserData() {
        const payload = {
          RelationType: "User",
          Id: store.getters["auth/userName"],
          Types: {
            User: "User"
          },
          StructuredReply: true
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for getUserData was successful", response);
            this.userData = response.data;
            this.userDetails = response.data.UserData.User.celldata[0];
            this.profilePicture = this.userDetails[21];
            this.dateOfBirth = this.userDetails[22];
            this.qrPicture = this.userDetails[29];
            if (this.userDetails[15] !== "" && this.userDetails[16] !== "" && this.userDetails[17] !== "") {
              var json_obj = JSON.parse(this.Get('https://nominatim.openstreetmap.org/search?q=' + this.userDetails[15] + '+' + this.userDetails[14] + ',+' + this.userDetails[17] + '&format=json&polygon=1&addressdetails=1'));
              if(!_.isEmpty(json_obj)){
                const lat = json_obj[0].lat;
                const lon = json_obj[0].lon;
                this.$store.commit("setUserOrderLon", lon);
                this.$store.commit("setUserOrderLat", lat);
              }
            }
          },
          error => {
            console.log("The call for getUserData was not successful", error);
          },
          "getUserData",
          this.$store.getters["auth/userName"],
          payload,
          600000,
          false
        );
      },
      getEventsOfUserInterests() {
        if (this.$store.getters["auth/userName"] === "") return;
        this.userInterests = false;
        let payload = {};
        let languageId = "";
        if (this.$store.getters.getUserLanguage == "") {
          languageId = 13;
        } else {
          languageId = this.$store.getters.getUserLanguage;
        }
        if (this.$store.getters["auth/partnerId"] > 0) {
          payload = {
            LanguageTagId: languageId,
            FunctionId: "EventFunctionLibrary::getEventsOfUserInterests",
            PartnerId: this.$store.getters["auth/partnerId"]
          };
        } else {
          payload = {
            LanguageTagId: languageId,
            FunctionId: "EventFunctionLibrary::getEventsOfUserInterests",
            PartnerId: -1
          };
        }
        dssRequest.doRequest(
          response => {
            console.log(
              "the call for getEventsOfUserInterests was successful",
              response
            );
            this.suggestionItems = [];
            // Adding the date to the events and saving the events in array favoriteItems

            for (const [key, value] of Object.entries(response.data.Events)) {
              value.Favourite = false;
              for (const [innerKey, innerValue] of Object.entries(
                this.$store.getters.getListOfFavourites
              )) {
                if (value.EventId == innerValue.EventId) {
                  value.Favourite = true;
                }
              }
              this.suggestionItems.push(value);
            }
            this.userInterests = true;
          },
          error => {
            console.log(
              "the call for getEventsOfUserInterests was not successful",
              error
            );
          },
          "communicateWithDBLibrary",
          this.$store.getters.getCurrentAccountId,
          payload
        );
      },
      getFavourites() {
        if (this.$store.getters["auth/userName"] === "") return;
        let languageId = "";
        if (this.$store.getters.getUserLanguage == "") {
          languageId = 13;
        } else {
          languageId = this.$store.getters.getUserLanguage;
        }
        let payload = {
          Runtime: true,
          LanguageTagId:languageId,
        };
        dssRequest.doRequest(
          response => {
            console.log("the call for getFavourites was successful", response);
            this.$store.commit("setListOfFavourites", response.data.Favourites);
            this.favoriteItems = [];
            // Adding the date to the events and saving the events in array favoriteItems

            for (const [key, value] of Object.entries(response.data.Favourites)) {
              value.Favourite = true;
              this.favoriteItems.push(value);
            }
          },
          error => {
            console.log("the call for getFavourites was not successful", error);
          },
          "getFavourites",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      deleteFavourite(item) {
        this.deletingFavourite = false;
        item.Favourite = !item.Favourite;
        let payload = {
          EventId: Number(item.EventId)
        };
        dssRequest.doRequest(
          response => {
            console.log("the call for deleteFavourite was successful", response);
            this.favoriteItems = [];
            this.getFavourites();
          },
          error => {
            console.log(
              "the call for deleteFavourite was not successful",
              error
            );
          },
          "deleteFavourite",
          this.$store.getters["auth/userName"],
          payload
        );
      },
      tryingToDeleteFavourite(eventData) {
        this.currentFavorite = eventData;
        this.deletingFavourite = true;
      },
      toggleFavourite(item) {
        let userId = this.$store.getters["auth/userName"];
        if (userId === "") {
          // User not logged in, go to login page
          this.goTo("Login");
          // this.$store.commit("setSaveFavourite", item.EventId);
        } else {
          this.seeTheListOfSuggestions = false;
          let functionCall = "";
          if (item.Favourite) {
            functionCall = "deleteFavourite";
          } else {
            functionCall = "addFavourite";
          }
          item.Favourite = !item.Favourite;
          this.seeTheListOfSuggestions = true;

          let payload = {
            EventId: Number(item.EventId)
          };
          dssRequest.doRequest(
            response => {
              console.log(
                "the call for " + functionCall + " was successful",
                response
              );
              this.getFavourites();
            },
            error => {
              console.log(
                "the call for " + functionCall + " was not successful",
                error
              );
            },
            functionCall,
            this.$store.getters["auth/userName"],
            payload
          );
        }
      },
      setBackgroundImageForAccount() {
        return this.$store.getters.getBackGroundImage;
      },
      goToPrivacyStatement(){
        this.$router.push({
          name: 'PrivacyStatement',
          params: 'component',
        });
      },
    }
  };
</script>
<style scoped lang="scss">
  .themeBackgroundPassport2 {
    background: none;
    /*margin-top: 1.2em !important;*/
    margin-left: -3.4em;
    margin-right: -3.4em;
    position: relative;
    bottom: 1.5em;
    min-height: 140em !important;
    height: auto;
  }
  .container {
    background: none;
  }
  .containerForPassport {
    padding-top: 7em;
    min-height: 600px;
    margin: auto;
  }
  .confirmLoadingDialog {
    border-radius: 1em !important;
  }
  .setFontSize {
    font-size: 15px;
  }
  .rounded-favourite-card-passport {
    border-radius: 10px !important;
  }
  .surroundingFavouritePassport {
    min-height: 600px;
    width: 80%;
    margin-top: -6em !important;
    margin: auto;
  }
  .surroundingInterestsPassport {
    min-height: 600px;
    margin: auto;
  }
  .favouriteImagePassport {
    min-height: 19em;
    max-height: 19em;
    padding: 1em;
  }
  .favouriteCardPassport {
    margin: 1em;
    border-radius: 10px !important;
  }
  .suggestionsImagePassport {
    border-radius: 10px;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    height: 90% !important;
    width: 90% !important;
  }
  .textWidthPassport {
    max-width: 85% !important;
  }
  .progressBarPassport {
    margin-top: 1em;
    margin-bottom: -1.5em;
  }
  .memberPhotoPassport {
    margin-left: 10%;
    margin-bottom: -3%;
    max-height: 15em !important;
    max-width: 15em !important;
  }
  .innerPassport {
    margin: 0.8em;
    padding-bottom: 2em;
    opacity: 0.8;
    background-color: white !important;
  }
  .rightPassportPhotoPassport {
    margin-top: -6em;
  }
  .leftPassportPhotoPassport {
    margin-top: -6em;
  }
  .midSection {
    margin-top: 4em;
  }
  .imageBlurPassport {
    margin-bottom: 10em;
    margin-top: -5em;
    height: 50em !important;
    width: 100%;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: absolute;
  }
  .imageBlurPassport2 {
    margin-top: -25em;
    height: 20em !important;
    width: 100%;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: absolute;
  }
  .passportCard {
    margin-top: -2em !important;
    padding-left: 2em;
    margin-top: 15%;
  }
  .formElements {
    padding-left: 0.4em;
    padding-right: 0.4em;
    margin-top: -0.5em;
  }
  .v-flex--reveal {
    width: 100%;
    padding: 1em;
    align-items: start;
    bottom: 0;
    opacity: 0.9;
    position: absolute;
    border-radius: 10px;
    cursor: pointer;
  }
  .personalImageUpload {
    position: relative;
    bottom: 3em;
    left: 2em;
    background-color: none;
    color: none;
  }
  .passportEvents {
    height: 10em !important;
  }
  .passPortText {
    color: black;
    text-shadow: 0 1px 0 white;
  }
  .toggleProducts {
    cursor: pointer;
    height: 5em;
    width: 50%;
    margin: auto;
    margin-top: 3em;
  }
  .blokje {
    width: 80%;
    max-width: 1000px;
    margin: auto;
  }
  .yourInterestsMobile {
    width: 100%;
    max-width: 1000px;
    margin: auto;
  }
  .text {
    margin-top: 1em;
  }
  .interestMidSection {
    max-height: 11em;
    overflow: auto;
  }
  .test {
    margin-top: -7em;
  }
  .MyAccountMobile {
    margin-top: 4em;
    margin-bottom: -3em;
  }
  .formMobile{
    margin-top: 7em;
  }
  .userInterests {
    padding: 1em 1em 0 1em;
    width: 100%;
  }
</style>
